export default (amount, options = {}, locale = 'en-US', currency = 'USD') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currencyDisplay: 'symbol',
    currency: currency,
    ...options,
  }).format(amount)
}
